module.exports = __webpack_public_path__ + "img/4f_r_sanko_1@2x.b870a0f8.jpg";